import Vue from 'vue'
import VueRouter from 'vue-router'
import homePage from '../views/homePage.vue'
import legalPage from '../views/legalPage.vue'
import CookieVue from '../views/CookieVue.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'homePage',
    component: homePage,
    meta: {
      title: '施乐辉中国官网'
    }
  },
  {
    path: '/CookieVue',
    name: 'CookieVue',
    component: CookieVue,
    meta: {
      title: 'Cookie使用条款'
    }
  },
  {
    path: '/legalPage',
    name: 'legalPage',
    component: legalPage,
    meta: {
      title: '法律声明'
    }
  },
]

const router = new VueRouter({
  routes
})

export default router
